import '../pages.css';
import { Link } from 'react-router-dom';

const EconomyAcrylicPartial = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/removable" className="back-link">← Back to Removable Prosthetics</Link>
                    <h1>Economy Acrylic Partial</h1>
                    <p className="product-tagline">Practical and affordable partial tooth replacement</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Economy acrylic partial dentures from <strong>AbELab</strong> offer a practical and affordable solution for patients
                            requiring partial tooth replacement. These restorations are fabricated using acrylic materials that provide acceptable
                            esthetics and function while remaining cost-effective. Designed primarily for budget-conscious cases, economy acrylic
                            partials restore basic mastication and appearance with reliable performance.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EconomyAcrylicPartial;
